import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { Card, CardActionArea, Stack, Text } from '@ltvco/refresh-lib/theme';
import { CarwiserModal } from '@ltvco/refresh-lib/v1';
import { Check } from '@mui/icons-material';
import { useContext, useState } from 'react';

const BENEFITS = [
  "Get paid on the spot, regardless of your car's condition",
  'Sell your car fast and easy, right from your home',
];

/**
 * In-feed marketplace ad promoting Carwiser (instant cash offer), ported from
 * the Ember `ads/carwiser-ad` component. Spliced into the results grid via
 * `ResultsGrid`'s `adSlots`; opens the existing `CarwiserModal` (already used
 * by the Rewards/Perks flow) on click, mounted the same conditional way.
 */
export function CarwiserAd() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { trackEvent } = useContext(AppConfig);

  const handleClick = () => {
    trackEvent('Carwiser', 'Click', 'card');
    setIsModalOpen(true);
  };

  return (
    <>
      <Card sx={{ height: '100%' }}>
        <CardActionArea
          onClick={handleClick}
          aria-label="Get an offer from Carwiser"
          sx={{ height: '100%', p: 2 }}
        >
          <Stack spacing={1.5} height="100%">
            <Text variant="h6" fontWeight={600}>
              Sell Your Car, Quick and Easy
            </Text>
            <Text variant="body2" color="text.secondary">
              Connect with our partner, CarWiser, for a quick and easy offer on
              your car
            </Text>
            <Stack spacing={0.75}>
              {BENEFITS.map((benefit) => (
                <Stack
                  key={benefit}
                  direction="row"
                  spacing={1}
                  alignItems="flex-start"
                >
                  <Check color="primary" sx={{ fontSize: '1rem', mt: 0.25 }} />
                  <Text variant="body2">{benefit}</Text>
                </Stack>
              ))}
            </Stack>
            <Text
              variant="body2"
              color="primary.main"
              fontWeight={600}
              mt="auto"
            >
              Get An Instant Offer
            </Text>
          </Stack>
        </CardActionArea>
      </Card>
      {isModalOpen && <CarwiserModal setIsOpen={setIsModalOpen} />}
    </>
  );
}
